import React, { useState } from 'react'
import { Flex, HStack, Spacer, InputRightElement, Text, Image, InputLeftElement, InputGroup, Container, Box, Center, Stack, Input, IconButton, FormLabel } from "@chakra-ui/react"
import { Link } from 'react-router-dom'
// import logo from "../Images/Dressify_1.png"
import { FaSearch,FaShoppingBag } from "react-icons/fa"

const TopNavbar = () => {

    return (
        <Box  bg="white"  width="80%" margin="auto" border="0px solid black">
            <Flex   >
                <HStack   >
                    <Link to="/">
                        <Text p={2}  _hover={{ bg: "#F2F2F2" }}  >WOMEN</Text>
                    </Link>
                    <Link to="men">
                        <Text _hover={{ bg: "#F2F2F2" }} p={2} >MEN</Text>
                    </Link>
                    <Link to="kids">
                        <Text _hover={{ bg: "#F2F2F2" }} p={2} >KIDS</Text>
                    </Link>
                    <Link to="life">
                        <Text _hover={{ bg: "#F2F2F2" }} p={2} >LIFE</Text>
                    </Link>
                </HStack>
                <Spacer />
                <HStack>
                    <Link>
                        <Text fontSize={11} fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.8px" color="Gray.800" _hover={{
                            color: "black",
                            fontWeight: "bold"
                        }} p={2} >Signup for Newsletter</Text>
                    </Link>
                    <Link>
                        <Text fontSize={11} fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.8px" color="Gray.800" _hover={{
                            color: "black",
                            fontWeight: "bold"
                        }} p={2} >My wishlist</Text>
                    </Link>
                    <Link>
                        <Text fontSize={11} fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.8px" color="Gray.800" _hover={{
                            color: "black",
                            fontWeight: "bold"
                        }} p={2} >Kazakhstan | English</Text>
                    </Link>
                </HStack>
            </Flex>
            <Flex  border="0px solid black" height="auto" width="full" margin="auto" >
                <Image border="0px solid black" w={300}  m="auto" mt={-20} src={process.env.PUBLIC_URL + "/Dressify_1.png"} />
                <FormLabel mt={2}>Shopping Bag</FormLabel>
                <IconButton colorScheme='BlackAlpha 300' icon={<FaShoppingBag color='black'/>}/>
            </Flex>
            <Flex mt={-55}  justify="space-between" border="0px solid black">
                <HStack>
                    <Link to="/">
                        <Text color="gray.500"  ml={2}>NEW ARRIVALS</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>DESIGNERS</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>CLOTHING</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>SHOES</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>BAGS</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>ACCESSORIES</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>FESTIVE SEASON</Text>
                    </Link>
                    <Link>
                        <Text color="gray.500" ml={2}>SALE</Text>
                    </Link>
                </HStack>
                <Flex border="0px solid black"  >
                    <InputGroup>
                        <Input placeholder='Search' />
                        <InputRightElement children={<FaSearch />} />
                    </InputGroup>
                </Flex>
            </Flex>
        </Box>
    )
}

export default TopNavbar